import React, { useState, useEffect } from "react";
import { CHAT_COLUMN_CLASS } from "../constants/chatLayout";

interface ReasoningBlockProps {
  content: string;
  isStreaming?: boolean;
}

export const ReasoningBlock: React.FC<ReasoningBlockProps> = ({
  content,
  isStreaming = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    if (!isStreaming && content) {
      setIsExpanded(false);
    }
  }, [isStreaming, content]);

  if (!content) return null;

  return (
    <div className={CHAT_COLUMN_CLASS}>
      <div className="w-full min-w-0">
        <div className="rounded-xl border border-theme-border bg-theme-surface-ui/60 overflow-hidden">
          <button
            type="button"
            onClick={() => setIsExpanded((v) => !v)}
            className="flex w-full items-center justify-between px-4 py-2.5 text-left hover:bg-theme-surface-ui transition-colors"
          >
            <div className="flex items-center gap-2">
              {isStreaming && (
                <div className="flex gap-0.5">
                  <span
                    className="h-1.5 w-1.5 animate-bounce rounded-full bg-theme-fg-muted"
                    style={{ animationDelay: "0s" }}
                  />
                  <span
                    className="h-1.5 w-1.5 animate-bounce rounded-full bg-theme-fg-muted"
                    style={{ animationDelay: "0.1s" }}
                  />
                  <span
                    className="h-1.5 w-1.5 animate-bounce rounded-full bg-theme-fg-muted"
                    style={{ animationDelay: "0.2s" }}
                  />
                </div>
              )}
              <span className="text-xs font-medium text-theme-fg-muted">
                {isStreaming ? "Thinking..." : "Reasoning"}
              </span>
            </div>
            <svg
              className={`h-4 w-4 text-theme-fg-muted transition-transform ${isExpanded ? "rotate-180" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
          {isExpanded && (
            <div className="border-t border-theme-border px-4 py-3 max-h-60 overflow-y-auto">
              <p className="whitespace-pre-wrap text-xs leading-relaxed text-theme-fg-muted">
                {content}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
